<ion-header>
  <ion-toolbar color="white-0">
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
        data-testid="user-experience-feedback-modal-close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content data-testid="user-experience-feedback-modal">
  <mable-heading heading="h2">How are we doing?</mable-heading>
  <div class="ion-padding-horizontal">
    <p>Are you enjoying your experience on the Mable app?</p>
    <mable-button
      expand="block"
      class="ion-margin-bottom"
      (onClick)="dismiss()"
    >
      <ion-icon
        aria-hidden="true"
        name="thumbs-up"
      ></ion-icon>
      Yes
    </mable-button>
    <mable-button
      expand="block"
      category="outline"
      (onClick)="openFeedbackModal()"
    >
      <ion-icon
        aria-hidden="true"
        name="thumbs-down"
      ></ion-icon>
      No
    </mable-button>
  </div>
</ion-content>
